import React from "react";
import "./ContactStyles.css";
import ContactOptions from "./ContactOptions/ContactOptions";
import { FiPhoneCall } from "react-icons/fi";
import { AiOutlineMail } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import LightSpeed from "react-reveal/LightSpeed";
import Slide from "react-reveal/Slide";

function Contact() {
  return (
    <div className="contact">
      <div className="contact__top">
        <LightSpeed>
          <h1 className="contact__heading">Contact</h1>
          <p className="contact__subheading">Get in touch</p>
        </LightSpeed>
      </div>
      <div className="contact__body">
        <div className="contact__left">
          <Slide top>
            <ContactOptions
              icon={<FiPhoneCall fontSize="2rem" color="#845ec2" />}
              title="Call Me"
              description="+254 729 453 045"
            />
            <ContactOptions
              icon={<AiOutlineMail fontSize="2rem" color="#845ec2" />}
              title="Email"
              description="nobertlangat0@gmail.com"
            />
            <ContactOptions
              icon={<GoLocation fontSize="2rem" color="#845ec2" />}
              title="Location"
              description="Bomet county - Kenya"
            />
          </Slide>
        </div>
        <div className="contact__right">
          <Slide bottom>
            <form action="">
              <div className="form__name">
                <input type="text" placeholder="name" />
                <input type="email" placeholder="email" />
              </div>
              <input type="text" placeholder="project" />
              <textarea
                className="textarea"
                name="message"
                id="message"
                placeholder="message"
                cols="30"
                rows="10"
              ></textarea>
              <button className="form__btn">Send Message</button>
            </form>
          </Slide>
        </div>
      </div>
    </div>
  );
}

export default Contact;
